import { type RefObject, useEffect, useState } from 'react';

export function useCheckOverflow(ref: RefObject<HTMLElement>) {
  const [isOverflown, setIsOverflown] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const checkOverflow = () => {
      setIsOverflown(
        element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight,
      );
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    const mutationObserver = new MutationObserver(checkOverflow);

    resizeObserver.observe(element);
    // characterData catches React updating an existing text node in place, which childList alone does not report
    mutationObserver.observe(element, { childList: true, subtree: true, characterData: true });

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [ref]);

  return isOverflown;
}
